import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchInvestmentSecurityAttributes } from '@apis/investmentIndicators';
import type { InvestmentSecurityAttributesApiData } from '@app-types/investmentIndicatorsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

export const useInvestmentSecurityAttributes = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<InvestmentSecurityAttributesApiData>({
    queryKey: ['indicators', 'security-attributes', ticker, mkt],
    queryFn: () => fetchInvestmentSecurityAttributes({
      ticker: ticker as string,
      mkt: mkt as string,
    }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};

